var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationFamily(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 238,
    viewBox: "0 0 327 238",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "xob1d7y8aa",
    d: "M0 0h5.204v5.368H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "770ran6o3c",
    d: "M0 0h44.542v33.326H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.904c0 10.44 8.463 18.903 18.904 18.903 10.44 0 18.903-8.463 18.903-18.903S29.344 0 18.904 0 0 8.464 0 18.904",
    id: "i9oe8hl9pe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.904c0 10.44 8.463 18.903 18.904 18.903 10.44 0 18.903-8.463 18.903-18.903S29.344 0 18.904 0 0 8.464 0 18.904z",
    id: "q3jcf6ytdg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.904c0 10.44 8.463 18.903 18.904 18.903 10.44 0 18.903-8.463 18.903-18.903S29.344 0 18.904 0 0 8.464 0 18.904z",
    id: "61uds8149i"
  }), /*#__PURE__*/React.createElement("path", {
    id: "58d7pezhfk",
    d: "M0 0h5.204v5.368H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "e0n5jolt4m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "8v8vca2tso"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "2hf037r4eq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "bo7megp02s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "r2wlprepsu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "se85e0mxqw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "8bzwfl5qsy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "vokfn9q81A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "u56qawxswC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "l7zffqnpdE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "j5gos2tucG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "zkzgegt8wI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "xcuyu8wssK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "1dybg1yukM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "1rd3x3hleO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "dyfrcy8d6Q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "qi7tqzkvgS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "hz5wkgohoU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "c2u0pxasyW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "ihhzxfdzvY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "1g5rnp319aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "w85bvr3osac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "umptf80exae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "jtksqofnvag"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "p37lh6olxai"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "74c60zj50ak"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "cvnh5y9ndam"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "ryepipx66ao"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "fpsfi4msuaq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "oelzu5gcaas"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "6hwjg2bjvau"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "sublnkywlaw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "zzw42qwyway"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "5dhzcjidmaA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "dm0c22f5faC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "ng9draie1aE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "svae3vnleaG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "717x5eij5aI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "6i163vvd4aK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "czheos748aM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "swnas6ehiaO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "jncyq6vpxaQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "mpwf5j39vaS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "5b5rl9c1faU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "ejwyvlkhsaW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "tgqp9uj38aY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "hjuk0olqqba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "jzjjdkx9abc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "j3awjo0e7be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "qvb1a7vvibg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "qewqi31t3bi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "g0142v9adbk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "yneh7ttkvbm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "eaok15ejgbo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "ukpnf3taebq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "lnlpnnhplbs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "981tytekwbu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "074b1luznbw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "7kmkz9zjcby"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "pfvnpvs69bA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "k52hhxdkkbC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "e3pxblduvbE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "a3jamzimcbG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "nw6wupcf9bI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "m96y8bi0pbK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "8538cciwzbM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "m67819f8qbO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "5rqc5k75rbQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "48yied51xbS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "fbzvxnidzbU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "xm0newiwybW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "0hrwskq25bY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "t37jv98mmca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "qots3zvydcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "t7e3jgh2hce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "8jsfgbse7cg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "qp154qlk3ci"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "mge62cawtck"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "rwtamcmgxcm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "egcqrvfdxco"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "cvez90iracq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "68s8jbxarcs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "g8cdrohgecu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "h61ewoyhzcw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "bw6kjwkbucy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "67usej5pxcA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "0pq4br7dbcC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "bae8urgnecE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "d9h8n62zocG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "a4npdfprocI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "g1lurhjovcK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "vovfqq5uscM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "645daa6pkcO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "05k4jev12cQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "1qc0mjn70cS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "j9fr8nveacU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "8d2jlvxiocW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "ibg7n2olbcY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "pm4072ydkda"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "4fnylk531dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "59iuk9cm7de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "m2bfntwgpdg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 0S-1.467 43.523.273 55.03c6 1.691 73.709 0 73.709 0C76.123 34.52 68.838 0 68.838 0",
    id: "ptpjaxeqldi"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kcq3haztwdk",
    d: "M0 0h44.427v33.387H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FE912A",
    d: "M9.297 164.865h290.062V97.927H9.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC988",
    d: "M18.594 151.23h55.781V97.926H18.594zM88.63 151.23h55.781V97.926h-55.78zM164.245 151.23h55.781V97.926h-55.781zM234.281 151.23h55.781V97.926h-55.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E87512",
    d: "M0 174.781h312.995v-11.776H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m123.958 195.775-4.973 16.801-4.943 1.252 3.279-19.833zM102.885 194.615l1.25 17.354h4.66l.908-17.354z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.902 203.911-10-1.454 5.049-43.01h19.507s-4.056 26.8-14.556 44.464M110.779 202.665h-10.223s-6.92-23.067-4.302-48.419l16.647 1.263s1.497 11.414-2.122 47.156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.09 159.448h11.054s-.243-6.27 2.256-6.365c3.287-.125 2.55 6.365 2.55 6.365h19.508s2.766-16.498.453-21.183c-1.472-2.981-10.441-9.968-10.441-9.968l-31.807.497c-5.813 3.651-7.8 9.47-7.644 15.078.24 8.63 6.3 15.576 14.071 15.576"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m126.22 128.917 2.697-28.265-.503-14.226-12.579-3.374-15.265 1.43-8.221 14.88 1.91 15.741 6.311 8.637z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.99 84.316c0 3.994 3.245 7.232 7.25 7.232 4.004 0 8.99-3.238 8.99-7.232l.996.146 4.91 23.467c.187.899.239 1.82.152 2.734l-1.7 17.786-27.607.497h-2.593l-1.84-14.32s3.253-12.893 2.392-22.052c-.862-9.16 9.05-8.258 9.05-8.258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.49 85.418S94.173 83.68 90.707 95.95c-3.57 12.64-7.277 34.393-6.238 36.294 1.04 1.902 23.394 10.364 33.945 8.05 8.334-1.828 11.37-7.185 11.107-7.703-.523-1.036-4.118 1.381-5.892 2.242-1.773.861-3.985 1.732-3.985 1.732s2.208-3.283.822-3.11c-1.387.172-3.074 3.456-3.074 3.456s-4.79.173-11.436-3.284-12.649-6.568-12.476-7.259c.173-.69 5.83-17.749 5.83-17.749l3.18-23.202z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M101.026 219.406h9.917v-2.479h-9.917zM110.943 216.927c-1.616-2.114-3.78-8.417-5.669-6.438-1.904 1.995-3.349 4.939-4.248 6.438h9.917z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.642 213.518c.976.664 5.193 2.616 5.193 2.616l1.835-2.15",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.642 213.518c.976.664 5.193 2.616 5.193 2.616l1.835-2.15",
    stroke: "#FEFEFE",
    strokeWidth: 1.137
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M112.182 219.406h9.917v-2.479h-9.917zM112.43 216.927c1.631-2.13 3.817-8.483 5.726-6.49 1.923 2.012 3.382 4.98 4.29 6.49H112.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.815 213.491c-.987.669-5.246 2.637-5.246 2.637l-1.853-2.168",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.815 213.491c-.987.669-5.246 2.637-5.246 2.637l-1.853-2.168",
    stroke: "#FEFEFE",
    strokeWidth: 1.137
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.755 84.462 2.54-12.738c-1.711-1.94-2.886-4.33-2.737-7.032.428-7.782 11.319-6.239 13.492-2.347.915 1.638 1.427 4.349 1.512 6.996l1.338 2.89a.623.623 0 0 1-.643.879l-.876-.106c-.3 2.073-.953 3.654-1.975 3.934-.546.149-1.408.058-2.433-.245l-.065 8.738s.492-.819-2.659.64c-5.054 2.339-7.494-1.609-7.494-1.609",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.904 64.095c-.094-.507-.315-1.07-.493-1.548-.23-.616-.572-1.17-.947-1.693a12.95 12.95 0 0 0-2.477-2.595c-1.693-1.333-3.833-2.084-5.923-1.797a6.062 6.062 0 0 0-2.937 1.242c-.78.617-.273 1.797-1.293 1.876 0 0-2.335-2.872-3.643.92-1.307 3.79 2.278 3.038-1.382 4.473-3.659 1.435-8.61 9.008-6.735 12.902 1.193 2.477-1.768 6.596-3.57 7.82-3.683 2.502-2.845 5.24-1.438 6.835 1.407 1.596 3.774 2.5 5.23 2.76 2.354.423 8.127.486 9.074-3.009.947-3.497-.818-3.892.779-4.433 1.597-.54 3.668-1.702 2.902-3.715-1.498-3.937 4.36-4.974 2.702-7.13-2.814-3.663-.908-4.817-1.344-5.321-.174-.2-.472-.916-.692-1.033-.255-.134-.2-.843-.4-1.066-.81-.9-.035-2.77.962-3.093 1.481-.477 1.847 1.614 2.918 2.14.615.302 1.248-.133 1.698-.576.605-.592 1.01-1.37 1.359-2.162.287-.651.553-1.313.846-1.96.137-.304.614-1.162.363-1.498 1.063-.228 2.256.196 3.183.76.384.233.677.493.886.911.044.09.143.359.261.367.221.018.134-.25.111-.377",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.278 68.848a2.74 2.74 0 0 0 2.947 2.513 2.735 2.735 0 0 0 2.522-2.935 2.74 2.74 0 0 0-2.946-2.512 2.735 2.735 0 0 0-2.523 2.934",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22244E",
    strokeWidth: 1.169,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m118.38 68.514-4.958-.674"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.882 57.142c.427 1.787-14.483 6.854-33.305 11.318-18.821 4.464-34.427 6.635-34.854 4.848-.429-1.785 14.482-6.853 33.305-11.317 18.82-4.465 34.426-6.635 34.854-4.849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.352 66.505c-1.568-5.869 1.943-11.892 7.84-13.451 5.898-1.56 11.951 1.933 13.519 7.803l-21.36 5.648zM125.187 85.819s8.277-1.725 11.726 10.456c3.552 12.55 7.242 34.144 6.208 36.031-1.035 1.889-23.28 10.29-33.78 7.992-8.294-1.814-11.314-7.133-11.053-7.648.52-1.028 4.097 1.372 5.863 2.227 1.765.854 3.966 1.72 3.966 1.72s-2.198-3.26-.818-3.09c1.38.172 3.059 3.432 3.059 3.432s4.767.172 11.38-3.26c6.614-3.431 12.588-6.52 12.416-7.206-.173-.686-5.802-17.62-5.802-17.62l-3.165-23.034z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m218.28 47.724-7.55 13.016 13.214-1.053 1.66-9.666z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.885 55.112c6.078-13.102.282-21.715-5.205-22.987 0 0-5.844 7.847-9.612 17.3l14.817 5.687c-1.22 2.629-2.84 3.148-2.84 3.148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.479 18.99c1.778-2.11 1.63-5.04 1.428-7.935-.58-8.342-12.075-6.507-14.311-2.296-2.237 4.21-2.173 14.242.717 14.994.41.277 1.439.277 3.144-.345l-.82 10.841 11.678-.593-1.836-14.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.159 11.977c-.355 4.988-1.293 7.484-2.814 7.484-2.282 0-4.355-1.508-5.356-1.508l.182 1.855c.399.563 2.215.904 2.215 1.779 0 .875-1.535.198-1.535.717 0 .859-.27 2.472 1.205 2.472 1.492 0 5.77-.55 6.505-2.787.473-1.444.779-4.437.917-8.978.091-.01.184-.016.276-.016 1.28 0 2.316 1.047 2.316 2.339 0 .655-.267 1.248-.697 1.673a35.084 35.084 0 0 0 1.823 2.385c7.114-1.622 7.39-9.68 4.206-13.398-3.423-3.994-14.76-3.928-15.003.19 0 2.486-.882 3.2 3.189 3.135 1 .534 1.77 1.453 2.57 2.658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.296 13.258-1.516 3.806a.286.286 0 0 0 .263.394h2.068l-.815-4.2zM223.167 9.744c1.34-5.138 5.507-9.226 12.627-7.472 6.502 1.602 8.379 7.858 6.436 12.553l-19.063-5.081z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 1.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m216.307 7.438 17.974 4.338"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 2.733,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M322.912 153.089 148.214 16.329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.46 133.667-19.52-27.89S221.17 99.6 186.969 67.663c-38.206-35.675-51.762-54.931-56.252-62.296-.83-1.36 1.82-4.182 3.404-4.005 8.929.993 32.167 6.469 75.606 39.693 20.589 15.748 46.967 51.653 46.967 51.653l34.348 6.768s.488 25.836-23.581 34.19",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.913 127.113s7.636-6.757 9.622-14.364c0 0-26.931-9.706-35.086-14.574-41.603-55.443-111.103-90.36-120.953-96.117-3.591-2.098-1.516.088-1.516.088s-2.74-.73.15 1.903c12.568 11.457 54.753 65.157 120.231 97.351 7.133 6.157 27.552 25.713 27.552 25.713",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.917)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qshikglqxb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xob1d7y8aa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.929 4.63.87.738 3.405-4.005-.872-.74A2.633 2.633 0 0 0 .625.928 2.625 2.625 0 0 0 .929 4.63",
    fill: "#FEFEFE",
    mask: "url(#qshikglqxb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m238.605 89.87 4.353 59.5-2.007 59.5h-5.994l-5.785-58.98-4.188-60.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.19 207.27c.476 1.268.714 2.218.714 2.848 0 .767-.128 1.885-.384 3.355h-24.032c-.625-2.06-.264-3.17 1.082-3.335 1.345-.164 2.463-.313 3.353-.444l11.17-4.967a.427.427 0 0 1 .568.225l.717 1.738c1.246.58 2.259.87 3.038.87.631 0 1.506-.255 2.62-.765a.853.853 0 0 1 1.13.419c.008.018.017.036.024.055",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.079 90.328-17.633 56.424a14.72 14.72 0 0 0-.314 7.61l13.166 58.728 6.292 1.412-3.934-64.049 13.646-60.125h-11.223z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.122 211.653c.476 1.269.714 2.218.714 2.849 0 .766-.128 1.884-.383 3.355H203.42c-.625-2.06-.264-3.171 1.082-3.335 1.345-.165 2.463-.313 3.353-.445l11.17-4.967a.427.427 0 0 1 .568.226l.717 1.738c1.246.579 2.258.869 3.038.869.631 0 1.506-.255 2.62-.765a.852.852 0 0 1 1.154.475M226.185 148.83l-.256-2.09 2.267-60.928 22.944-6.106-4.2 68.837s-9.374 6.493-20.755.287",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.837 149.7 23.303-60.166-36.029-3.45-11.988 59.383s10.65 7.475 24.714 4.234",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.694 26.05s6.105-1.263 10.678 17.187c4.572 18.45 5.698 54.947 5.698 54.947s-11.602 13.12-46.132 0l11.761-41.8 4.045-24.374 13.95-5.96z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.546 53.534c.05-5.574.306-14.312-1.005-17.305-3.773-8.608-10.579-5.735-10.579-5.735s-5.516 1.633-5.797 8.069c-.115 2.625.11 7.95.419 13.34l16.962 1.631zM232.895 71.712c0 8.27-6.72 14.973-15.011 14.973-8.29 0-15.012-6.704-15.012-14.973 0-8.269 6.721-14.972 15.012-14.972 8.29 0 15.011 6.703 15.011 14.972",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.172 67.337c0 9.707-7.89 17.577-17.622 17.577s-17.621-7.87-17.621-17.577 7.889-17.576 17.621-17.576 17.622 7.87 17.622 17.576",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.059 73.029h63.152s7.288 34.592 5.144 55.145c0 0-67.736 1.696-73.737 0-1.741-11.53 5.441-55.145 5.441-55.145",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.988 68.852.333-22.519-11.949-2.73.242 23.729c-7.852 12.417-18.69 35.927-19.134 36.683-.826 1.408-4.656 1.532-5.924 2.148a.6.6 0 0 0-.295.783c.793 1.725 3.783-.3 4.413 2.478.608 2.681-3.866 5.516-1.306 6.97.39.146 3.99.529 5.297-2.067 1.536-3.052.503-6.632.955-7.555.573-1.168 25.315-32.588 25.315-32.588a8.29 8.29 0 0 0 2.053-5.332",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.88 77.941h-.046c-.362-.026-5.858-.383-3.235-1.083.35-.094 3.885-36.898-3.435-44.323-1.209-1.225-2.535-1.704-4.08-1.705-12.741-.01-18.663 44.887-18.663 44.887-.36.047-3.134.377-3.494.314a.657.657 0 0 1-.533-.762c.328-1.837 8.213-45.015 22.624-45.75 1.903-.1 3.617.608 5.084 2.096 8.807 8.927 6.535 44.216 6.434 45.714a.658.658 0 0 1-.656.612M205.14 163.69c-.292 5.828-17.401 9.716-38.216 8.684-20.815-1.033-37.454-6.594-37.163-12.422.29-5.828 17.4-9.715 38.215-8.682 20.815 1.032 37.454 6.593 37.163 12.42M166.516 127.123s-6.223-1.161-9.196 4.379c-2.974 5.54-5.564 4.939-5.317 6.937.248 1.997 1.649 2.49.812 3.812-.837 1.323 1.351 3.814 4.382 4.08 3.03.265 4.486-.316 8.046.937 3.558 1.252 5.74.576 6.896-.773 2.496-2.912 3.469-3.114 4.968-3.04 3.229.16 4.266-3.225 2.388-4.632-3.49-2.616-2.24-10.714-12.98-11.7",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.715 133.312s-5.806 10.954 5.477 11.858c10.42.837 8.4-9.671 5.621-11.884l-11.098.026zM119 216.379s39.202-16.61 44.933-10.257c5.73 6.354-27.87 29.692-27.87 29.692s1.53-11.933-9.605-9.585c0 0 3.278-10.14-7.458-9.85",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.896 204.674)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r0dj0czkkd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#770ran6o3c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.542 15.675S7.186-4.732.851 1.023C-5.484 6.778 25.63 33.326 25.63 33.326s-.335-12.025 10.512-8.587c0 0-2.253-10.414 8.4-9.064",
    fill: "#FEFEFE",
    mask: "url(#r0dj0czkkd)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.93 166.703s-.74 14.837 6.266 38.65c0 0-.537 2.717 1.366 3.372 1.807.62 2.083-.31 2.645-1.009.277-.344.425-.773.439-1.215l1.945-37.37-12.662-2.428z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.1 206.67c.344-4.949 1.663-28.918.639-38.786l-12.636 3.874 7.72 36.232c.104.548.445 1.027.943 1.281.577.293.609.53 1.856.278 1.586-.321 1.477-2.879 1.477-2.879",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.655 136.974 1.647-.495m-12.041-.072-1.594-.673",
    stroke: "#FEFEFE",
    strokeWidth: 1.476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.955 135.783s.053-1.505 2.429-1.262c2.487.255 2.933 1.406 2.893 2.17-.039.74-.994 1.897-3.306 1.787-2.312-.109-2.107-2.285-2.016-2.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.002 137.876c-.531-.025-.904-.18-1.14-.47-.396-.489-.339-1.266-.287-1.5 0 0 .03-.923 1.523-.8.072.005.147.008.225.015 1.542.14 2.366.687 2.321 1.539-.024.468-.717 1.307-2.642 1.216M171.672 136.337s.103-1.502-2.286-1.484c-2.5.018-3.065 1.122-3.104 1.885-.039.74.79 1.981 3.103 2.091 2.312.11 2.334-2.075 2.287-2.492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.417 138.227c.531.025.918-.093 1.183-.36.446-.45.47-1.228.442-1.465 0 0 .068-.921-1.431-.94-.074-.002-.149-.006-.227-.006-1.548-.006-2.425.46-2.47 1.312-.025.468.578 1.368 2.503 1.46z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 1.476,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m164.865 136.94 1.239.067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.286 132.957s2.24.88 6.51.917c4.27.037 6.506-.795 6.506-.795l-2.227-4.162-8.662.075-2.127 3.965zM170.089 149.99l-9.563-.466.354-6.972 9.563.465z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.466 187.177c-31.128.032-41.982-11.39-42.675-18.438-.198-6.732 4.667-11.781 10.78-9.762 0 0 14.518 4.1 32.578 4.634 27.897.826 37.453-5.795 42.3 3.632.904 1.761.895 1.856.79 3.984l-.736 1.202c-.282 5.674-8.115 14.713-43.037 14.748",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.455 116.827c-7.362 25.292-20.99 35.907-32.076 38.941l-.562 8.374s-6.135 1.003-15.913.188c-5.17-.257-12.675-1.295-12.675-1.295l.287-8.703c-10.89-1.64-26.659 4.838-25.626 9.321.358 1.558 2.836 6.333 1.45 7.052-1.387.719-2.466-3.386-3.046-2.739-.451.501 1.743 4.025 2.57 5.53.825 1.505-.935 2.767-3.565-.809-3.09-4.202-1.31-9.791-1.31-9.791 6.18-20.182 37.782-16.934 37.782-16.934l3.911.194 1.477.074 11.51.572s21.125-2.152 32.086-31.419l2.136-.786 1.564 2.23z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.729 160.637s26.99 7.415 51.736 1.826",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.729 160.637s26.99 7.415 51.736 1.826",
    stroke: "#E10A0A",
    strokeWidth: 0.911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.304 145.938s.091 6.084 6.429 5.95c6.336-.136 6.593-5.302 6.593-5.302l4.342.216s-1.37 8.432 3.71 8.966l-.56 8.374s-10.859.59-16.441.162c-5.584-.428-12.148-1.27-12.148-1.27l.286-8.702s3.686-2.836 3.465-8.562l4.324.168zM208.755 115.383c-.074-1.598-2.004-7.317-.512-7.776 1.491-.46 1.946 2.33 2.633 1.797.534-.414-.773-2.256-1.315-3.885-.542-1.628 1.414-2.556 3.36 1.436 2.285 4.69-.466 9.872-.466 9.872",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BA7A45",
    d: "m125.818 195.775-4.973 16.801-4.944 1.252 3.279-19.833zM104.125 194.615l1.25 17.354h4.66l.908-17.354z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#AAE2BC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.761 203.911-10-1.454 5.05-43.01h19.506s-4.056 26.8-14.556 44.464M112.638 202.665h-10.223s-6.92-23.067-4.301-48.419l16.646 1.263s1.497 11.414-2.122 47.156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.95 159.448h11.054s-.243-6.27 2.255-6.365c3.288-.125 2.551 6.365 2.551 6.365h19.507s2.766-16.498.454-21.183c-1.472-2.981-10.442-9.968-10.442-9.968l-31.807.497c-5.813 3.651-7.8 9.47-7.644 15.078.24 8.63 6.3 15.576 14.072 15.576"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BA7A45",
    d: "m128.08 128.917 2.696-28.265-.503-14.226-12.579-3.374-15.264 1.43-8.222 14.88 1.911 15.741 6.31 8.637z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.849 84.316c0 3.994 3.246 7.232 7.25 7.232s8.99-3.238 8.99-7.232l.996.146 4.91 23.467c.188.899.239 1.82.152 2.734l-1.7 17.786-27.606.497h-2.594l-1.84-14.32s3.253-12.893 2.392-22.052c-.862-9.16 9.05-8.258 9.05-8.258",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.35 85.418S96.032 83.68 92.567 95.95c-3.57 12.64-7.277 34.393-6.238 36.294 1.04 1.902 23.394 10.364 33.944 8.05 8.335-1.828 11.37-7.185 11.107-7.703-.523-1.036-4.117 1.381-5.892 2.242-1.773.861-3.984 1.732-3.984 1.732s2.207-3.283.82-3.11c-1.385.172-3.073 3.456-3.073 3.456s-4.79.173-11.436-3.284-12.649-6.568-12.475-7.259c.173-.69 5.83-17.749 5.83-17.749l3.18-23.202z",
    fill: "#BA7A45"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#22244E",
    d: "M102.885 219.406h9.917v-2.479h-9.917z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.802 216.927c-1.615-2.114-3.78-8.417-5.668-6.438-1.905 1.995-3.35 4.939-4.249 6.438h9.917z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 213.518c.978.664 5.194 2.616 5.194 2.616l1.835-2.15",
    stroke: "#FEFEFE",
    strokeWidth: 1.137
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#22244E",
    d: "M114.042 219.406h9.916v-2.479h-9.916z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.29 216.927c1.63-2.13 3.817-8.483 5.725-6.49 1.924 2.012 3.382 4.98 4.29 6.49H114.29z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.674 213.491c-.986.669-5.245 2.637-5.245 2.637l-1.854-2.168",
    stroke: "#FEFEFE",
    strokeWidth: 1.137
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.615 84.462 2.539-12.738c-1.71-1.94-2.885-4.33-2.737-7.032.428-7.782 11.32-6.239 13.493-2.347.915 1.638 1.427 4.349 1.512 6.996l1.337 2.89a.623.623 0 0 1-.642.879l-.877-.106c-.3 2.073-.952 3.654-1.974 3.934-.546.149-1.408.058-2.433-.245l-.066 8.738s.492-.819-2.658.64c-5.055 2.339-7.494-1.609-7.494-1.609",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.764 64.095c-.095-.507-.316-1.07-.494-1.548-.23-.616-.572-1.17-.947-1.693a12.95 12.95 0 0 0-2.476-2.595c-1.693-1.333-3.834-2.084-5.923-1.797a6.062 6.062 0 0 0-2.938 1.242c-.78.617-.272 1.797-1.293 1.876 0 0-2.335-2.872-3.642.92-1.308 3.79 2.277 3.038-1.382 4.473-3.66 1.435-8.61 9.008-6.735 12.902 1.192 2.477-1.769 6.596-3.57 7.82-3.683 2.502-2.845 5.24-1.439 6.835 1.407 1.596 3.774 2.5 5.23 2.76 2.354.423 8.127.486 9.075-3.009.947-3.497-.819-3.892.778-4.433 1.598-.54 3.668-1.702 2.902-3.715-1.498-3.937 4.36-4.974 2.702-7.13-2.814-3.663-.907-4.817-1.344-5.321-.174-.2-.472-.916-.691-1.033-.256-.134-.2-.843-.4-1.066-.811-.9-.035-2.77.962-3.093 1.48-.477 1.846 1.614 2.918 2.14.615.302 1.247-.133 1.698-.576.604-.592 1.01-1.37 1.358-2.162.287-.651.554-1.313.847-1.96.137-.304.613-1.162.362-1.498 1.063-.228 2.257.196 3.183.76.384.233.677.493.886.911.045.09.143.359.262.367.22.018.134-.25.11-.377",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.138 68.848a2.74 2.74 0 0 0 2.946 2.513 2.735 2.735 0 0 0 2.523-2.935 2.74 2.74 0 0 0-2.947-2.512 2.735 2.735 0 0 0-2.522 2.934",
    fill: "#22244E"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#22244E",
    strokeWidth: 1.169,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m120.24 68.514-4.959-.674"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.121 57.162c.428 1.795-14.483 6.885-33.305 11.369-18.82 4.484-34.426 6.665-34.854 4.87-.428-1.793 14.483-6.884 33.305-11.368 18.821-4.485 34.427-6.665 34.854-4.87",
    fill: "#DFE15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.591 66.567c-1.567-5.895 1.943-11.945 7.841-13.511 5.898-1.567 11.951 1.941 13.518 7.838l-21.359 5.673z",
    fill: "#DFE15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.867 121.872c0 10.394-8.43 18.82-18.83 18.82-10.398 0-18.83-8.426-18.83-18.82 0-10.395 8.432-18.82 18.83-18.82 10.4 0 18.83 8.425 18.83 18.82",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.383 122.464a3.336 3.336 0 0 1-3.337 3.336 3.337 3.337 0 0 1-3.338-3.336 3.337 3.337 0 0 1 3.338-3.335 3.336 3.336 0 0 1 3.337 3.335",
    fill: "#E10A0A"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.068 102.885)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "edursl2vjf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i9oe8hl9pe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.793 17.774s9.17-6.871 9.536-14.028l5.226 9.993-.825 10.177s-9.536-4.125-13.203-3.759c-3.667.367-.734-2.383-.734-2.383",
    fill: "#E10A0A",
    mask: "url(#edursl2vjf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.068 102.885)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bu3dcbvr9h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q3jcf6ytdg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.682 17.132S21.034 1.729 13.974-2.213c-7.06-3.942-16.595 15.31-16.595 15.31s19.346 2.445 24.389 5.807l1.914-1.772z",
    fill: "#E10A0A",
    mask: "url(#bu3dcbvr9h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.068 102.885)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v150vrkh4j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#61uds8149i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.768 20.432s-11.92 13.11-19.53 13.57l11.644 5.684h13.4s-.088-13.57-3.351-18.704l-2.163-.55z",
    fill: "#E10A0A",
    mask: "url(#v150vrkh4j)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M126.833 85.616s8.317-1.732 11.782 10.495c3.57 12.595 7.278 34.27 6.239 36.164-1.04 1.896-23.394 10.327-33.945 8.022-8.334-1.822-11.37-7.16-11.107-7.676.523-1.032 4.117 1.377 5.892 2.234 1.773.858 3.985 1.726 3.985 1.726s-2.208-3.272-.822-3.1c1.387.172 3.074 3.444 3.074 3.444s4.79.173 11.436-3.272c6.646-3.444 12.649-6.544 12.476-7.232-.173-.689-5.83-17.686-5.83-17.686l-3.18-23.12zM220.14 47.724l-7.551 13.016 13.214-1.053 1.66-9.666z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M231.744 55.112c6.078-13.102.283-21.715-5.205-22.987 0 0-5.843 7.847-9.612 17.3l14.817 5.687c-1.22 2.629-2.839 3.148-2.839 3.148",
    fill: "#AAE2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.338 18.99c1.779-2.11 1.63-5.04 1.429-7.935-.58-8.342-12.076-6.507-14.312-2.296-2.236 4.21-2.172 14.242.717 14.994.41.277 1.44.277 3.144-.345l-.82 10.841 11.678-.593-1.836-14.667z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.018 11.977c-.355 4.988-1.292 7.484-2.813 7.484-2.282 0-4.355-1.508-5.356-1.508l.181 1.855c.399.563 2.215.904 2.215 1.779 0 .875-1.535.198-1.535.717 0 .859-.27 2.472 1.205 2.472 1.492 0 5.771-.55 6.505-2.787.473-1.444.78-4.437.918-8.978.09-.01.183-.016.275-.016 1.28 0 2.317 1.047 2.317 2.339 0 .655-.267 1.248-.698 1.673a35.084 35.084 0 0 0 1.824 2.385c7.113-1.622 7.39-9.68 4.205-13.398-3.422-3.994-14.76-3.928-15.002.19 0 2.486-.883 3.2 3.188 3.135 1 .534 1.77 1.453 2.571 2.658",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.156 13.258-1.516 3.806a.286.286 0 0 0 .262.394h2.068l-.814-4.2z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.026 9.744c1.341-5.138 5.508-9.226 12.628-7.472 6.501 1.602 8.378 7.858 6.435 12.553l-19.063-5.081z",
    fill: "#007371"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#007371",
    strokeWidth: 1.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m218.167 7.438 17.974 4.338"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#007371",
    strokeWidth: 2.733,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M324.771 153.089 150.072 16.329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.32 133.667-19.521-27.89s-26.768-6.176-60.97-38.113c-38.207-35.675-51.763-54.931-56.253-62.296-.83-1.36 1.82-4.182 3.404-4.005 8.93.993 32.168 6.469 75.606 39.693 20.59 15.748 46.967 51.653 46.967 51.653l34.349 6.768s.487 25.836-23.582 34.19",
    fill: "#E10A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.772 127.113s7.637-6.757 9.623-14.364c0 0-26.932-9.706-35.086-14.574-41.604-55.443-111.104-90.36-120.954-96.117-3.591-2.098-1.516.088-1.516.088s-2.74-.73.15 1.903c12.569 11.457 54.754 65.157 120.232 97.351 7.132 6.157 27.551 25.713 27.551 25.713",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.776)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8k22umr9ml",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#58d7pezhfk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.929 4.63.87.738 3.405-4.005-.872-.74A2.633 2.633 0 0 0 .625.928 2.625 2.625 0 0 0 .929 4.63",
    fill: "#007371",
    mask: "url(#8k22umr9ml)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#BA7A45",
    d: "m239.845 89.87 4.353 59.5-2.007 59.5h-5.994l-5.785-58.98-4.188-60.02z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243.44 207.562c.476 1.271.713 2.223.713 2.854 0 .767-.128 1.887-.384 3.36h-24.022c-.625-2.063-.264-3.176 1.081-3.34 1.345-.165 2.462-.314 3.352-.446l11.165-4.974a.426.426 0 0 1 .564.214c0 .004.002.008.004.012l.718 1.74c1.245.58 2.257.87 3.036.87.631 0 1.505-.254 2.619-.765a.852.852 0 0 1 1.13.42l.023.055",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.335 90.432-17.626 56.515a14.772 14.772 0 0 0-.314 7.623l13.161 58.822 6.29 1.414-3.933-64.152 13.64-60.222h-11.218z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.377 211.953c.477 1.27.714 2.222.714 2.853 0 .768-.128 1.888-.383 3.36h-24.023c-.625-2.062-.264-3.175 1.08-3.34 1.346-.164 2.463-.313 3.353-.445l11.165-4.975a.427.427 0 0 1 .568.226l.717 1.74c1.246.58 2.258.871 3.037.871.631 0 1.505-.255 2.62-.766a.851.851 0 0 1 1.152.476",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.44 149.028-.255-2.093 2.266-61.027 22.935-6.115-4.198 68.948s-9.371 6.504-20.747.287",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.092 149.9 23.294-60.264-36.014-3.455-11.984 59.479s10.646 7.487 24.704 4.24",
    fill: "#383A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.945 26.05s6.103-1.265 10.673 17.215c4.571 18.479 5.696 55.035 5.696 55.035s-11.597 13.141-46.113 0l11.756-41.867L226 32.02l13.945-5.97z",
    fill: "#AAE2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.795 53.579c.049-5.583.306-14.336-1.005-17.334-3.772-8.622-10.575-5.743-10.575-5.743s-5.514 1.635-5.795 8.08c-.114 2.63.11 7.965.419 13.363l16.956 1.634z",
    fill: "#AAE2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.148 71.786c0 8.283-6.718 14.997-15.005 14.997-8.288 0-15.006-6.714-15.006-14.997 0-8.282 6.718-14.996 15.006-14.996 8.287 0 15.005 6.714 15.005 14.996",
    fill: "#DFE15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.414 67.404c0 9.723-7.887 17.605-17.615 17.605-9.728 0-17.614-7.882-17.614-17.605s7.886-17.605 17.614-17.605c9.728 0 17.615 7.882 17.615 17.605",
    fill: "#F3F2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.325 73.105h63.128s7.285 34.648 5.142 55.234c0 0-67.71 1.698-73.708 0-1.74-11.55 5.438-55.234 5.438-55.234",
    fill: "#007371"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "otmq17hl9n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e0n5jolt4m"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#otmq17hl9n)",
    d: "m-70.767 7.879 4.64 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r0pxacq74p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8v8vca2tso"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#r0pxacq74p)",
    d: "m-14.522 9.125 4.639 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l4rnaiqocr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2hf037r4eq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#l4rnaiqocr)",
    d: "m-43.766 40.156 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "roslue7jut",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bo7megp02s"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#roslue7jut)",
    d: "m12.478 41.402 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tznhbl1u6v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r2wlprepsu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#tznhbl1u6v)",
    d: "m-38.762 49.014-4.64-5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e7eo17u5bx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#se85e0mxqw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#e7eo17u5bx)",
    d: "m-65.12 39.168 4.64 5.522"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vokcquwy6z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8bzwfl5qsy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#vokcquwy6z)",
    d: "m-8.875 40.414 4.64 5.522"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g5zg6ymqoB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vokfn9q81A"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#g5zg6ymqoB)",
    d: "m39.82 48.85 4.64 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8wopa06z4D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u56qawxswC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#8wopa06z4D)",
    d: "m-37.572 8.971 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rr4fj52isF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l7zffqnpdE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#rr4fj52isF)",
    d: "m18.673 10.217 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sj51i7d6gH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j5gos2tucG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#sj51i7d6gH)",
    d: "m-25.235 44.996 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lt1jurzu5J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zkzgegt8wI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#lt1jurzu5J)",
    d: "m-61.294 32.016 6.701 2.708"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s0v6mkmatL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xcuyu8wssK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#s0v6mkmatL)",
    d: "m-5.05 33.263 6.701 2.707"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h03xvoyvsN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1dybg1yukM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#h03xvoyvsN)",
    d: "m-33.872 16.188 6.747-2.591"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rx40qn405P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1rd3x3hleO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#rx40qn405P)",
    d: "m22.373 17.434 6.747-2.591"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eo2c8y3m4R",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dyfrcy8d6Q"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#eo2c8y3m4R)",
    d: "m-21.535 52.213 6.747-2.591"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6rllgduy0T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qi7tqzkvgS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#6rllgduy0T)",
    d: "m-56.448 22.041 4.639 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n2cwxydiwV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hz5wkgohoU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#n2cwxydiwV)",
    d: "m-.204 23.288 4.64 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f44c2rvn1X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2u0pxasyW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#f44c2rvn1X)",
    d: "m-29.202 26.245 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ltgtfgrtwZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ihhzxfdzvY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ltgtfgrtwZ)",
    d: "m27.043 27.491 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mvxolz7udab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1g5rnp319aa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#mvxolz7udab)",
    d: "m3.038 8.315 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ifuvqepf9ad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w85bvr3osac"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ifuvqepf9ad)",
    d: "m-59.404 18.649-7.18.867"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8uo5osi54af",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#umptf80exae"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#8uo5osi54af)",
    d: "m-3.159 19.896-7.18.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3qbg9not2ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jtksqofnvag"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#3qbg9not2ah)",
    d: "m22.691 46.313-7.179.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5is7h9snpaj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p37lh6olxai"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#5is7h9snpaj)",
    d: "m-32.217 29.585-7.162-.991"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "99xf6f193al",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#74c60zj50ak"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#99xf6f193al)",
    d: "m-1.76 7.005-7.162-.991"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ijri0c5t7an",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cvnh5y9ndam"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ijri0c5t7an)",
    d: "m24.028 30.831-7.162-.991"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yl661gf5rap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ryepipx66ao"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#yl661gf5rap)",
    d: "m-67.829 33.828-7.179.867"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hr6hopp6uar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fpsfi4msuaq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#hr6hopp6uar)",
    d: "m-11.584 35.075-7.179.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7jiw9xabnat",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oelzu5gcaas"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#7jiw9xabnat)",
    d: "m-45.861 13.863.995-7.131"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fp0gdvuubav",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6hwjg2bjvau"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#fp0gdvuubav)",
    d: "m10.383 15.109.996-7.131"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3k59gmb59ax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sublnkywlaw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#3k59gmb59ax)",
    d: "m-33.524 49.888.995-7.131"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ufw85emyhaz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zzw42qwyway"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ufw85emyhaz)",
    d: "m-71.397 18.724-7.07-1.507"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qak4m6516aB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5dhzcjidmaA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#qak4m6516aB)",
    d: "m-15.152 19.971-7.07-1.508"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mttul293saD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dm0c22f5faC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#mttul293saD)",
    d: "m-43.884 31.69-7.096 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o4gksg1wlaF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ng9draie1aE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#o4gksg1wlaF)",
    d: "m12.039 30.548-7.097 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xwmljm4rdaH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svae3vnleaG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#xwmljm4rdaH)",
    d: "M7.56 42.574.464 43.959"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "15y7h8chlaJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#717x5eij5aI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#15y7h8chlaJ)",
    d: "m-52.092 13.342-7.071-1.508"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pu91vzvqnaL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6i163vvd4aK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#pu91vzvqnaL)",
    d: "m4.153 14.589-7.071-1.508"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n10w2cwo1aN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#czheos748aM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#n10w2cwo1aN)",
    d: "m-24.998 35.019-7.097 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jwe4y6lp0aP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#swnas6ehiaO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#jwe4y6lp0aP)",
    d: "M31.246 36.265 24.15 37.65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6afmf1xu3aR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jncyq6vpxaQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#6afmf1xu3aR)",
    d: "m-57.437 43.551 7.07 1.508"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bc0cdej8faT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mpwf5j39vaS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#bc0cdej8faT)",
    d: "m-61.495 25.156-5.547 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0l1dua5unaV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5b5rl9c1faU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#0l1dua5unaV)",
    d: "m-5.251 26.403-5.546 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hyfwqtogiaX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ejwyvlkhsaW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#hyfwqtogiaX)",
    d: "m10.916 45.909-5.546 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jzmxxtd4haZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tgqp9uj38aY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#jzmxxtd4haZ)",
    d: "m-3.707 49.626-5.546 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y8346dj2gbb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hjuk0olqqba"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#y8346dj2gbb)",
    d: "m-34.193 23.043-5.465-4.715"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g5wbsemo8bd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jzjjdkx9abc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#g5wbsemo8bd)",
    d: "m-52.285 7.266-5.465-4.715"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i082f379obf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j3awjo0e7be"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#i082f379obf)",
    d: "m22.052 24.289-5.465-4.715"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mxukhlzn6bh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qvb1a7vvibg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#mxukhlzn6bh)",
    d: "m-72.787 25.058-5.547 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "omk2nejbfbj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qewqi31t3bi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#omk2nejbfbj)",
    d: "m-50.585 23.308 4.735-5.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ree79gh91bl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g0142v9adbk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ree79gh91bl)",
    d: "m5.659 24.554 4.736-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3vbxp9i4nbn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yneh7ttkvbm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#3vbxp9i4nbn)",
    d: "m-23.733 12.188 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vb3z96csebp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eaok15ejgbo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#vb3z96csebp)",
    d: "m32.734 8.779 4.64 5.522"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6yfj3so01br",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ukpnf3taebq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#6yfj3so01br)",
    d: "m88.979 10.025 4.64 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5h54h9wsabt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lnlpnnhplbs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#5h54h9wsabt)",
    d: "m59.735 41.055 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fuxd5pagbbv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#981tytekwbu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#fuxd5pagbbv)",
    d: "m115.98 42.302 4.735-5.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ewci0gvglbx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#074b1luznbw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ewci0gvglbx)",
    d: "m64.739 49.913-4.64-5.522"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9ihquts1abz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7kmkz9zjcby"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#9ihquts1abz)",
    d: "m38.381 40.067 4.64 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0i42v90fnbB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pfvnpvs69bA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#0i42v90fnbB)",
    d: "m94.626 41.313 4.64 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7qemweugbbD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k52hhxdkkbC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#7qemweugbbD)",
    d: "m65.93 9.87 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4ffnb6yxlbF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e3pxblduvbE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#4ffnb6yxlbF)",
    d: "m122.174 11.117 4.736-5.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ik0ifcy22bH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3jamzimcbG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ik0ifcy22bH)",
    d: "m78.267 45.896 4.735-5.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p14rj2cksbJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nw6wupcf9bI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#p14rj2cksbJ)",
    d: "m42.207 32.916 6.701 2.707"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tstxzkz8wbL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m96y8bi0pbK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#tstxzkz8wbL)",
    d: "m98.452 34.162 6.701 2.708"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sy19z2vbebN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8538cciwzbM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#sy19z2vbebN)",
    d: "m69.63 17.087 6.747-2.591"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8poclfgfmbP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m67819f8qbO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#8poclfgfmbP)",
    d: "m125.874 18.333 6.747-2.59"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "52a7or24lbR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5rqc5k75rbQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#52a7or24lbR)",
    d: "m81.967 53.112 6.747-2.59"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4l8u5xku5bT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#48yied51xbS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#4l8u5xku5bT)",
    d: "m47.053 22.941 4.64 5.522"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z1a0scke7bV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fbzvxnidzbU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#z1a0scke7bV)",
    d: "m103.298 24.187 4.64 5.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vvo1dayt4bX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xm0newiwybW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#vvo1dayt4bX)",
    d: "m74.3 27.145 4.735-5.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eay6mbevzbZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0hrwskq25bY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#eay6mbevzbZ)",
    d: "m130.545 28.391 4.735-5.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9rdum514wcb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t37jv98mmca"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#9rdum514wcb)",
    d: "m106.539 9.214 4.736-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "11uv4xmogcd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qots3zvydcc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#11uv4xmogcd)",
    d: "m44.097 19.549-7.179.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avfc29crbcf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t7e3jgh2hce"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#avfc29crbcf)",
    d: "m100.342 20.795-7.179.867"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "boy4c6nwtch",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8jsfgbse7cg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#boy4c6nwtch)",
    d: "m126.193 47.212-7.179.867"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7405s4e2wcj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qp154qlk3ci"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#7405s4e2wcj)",
    d: "m71.285 30.484-7.162-.991"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "48chtvq7xcl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mge62cawtck"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#48chtvq7xcl)",
    d: "m101.741 7.905-7.161-.992"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f1k95ng0pcn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rwtamcmgxcm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#f1k95ng0pcn)",
    d: "m127.529 31.731-7.162-.991"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g1bol8ztvcp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#egcqrvfdxco"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#g1bol8ztvcp)",
    d: "m91.918 35.974-7.18.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nh2pze1qncr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cvez90iracq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#nh2pze1qncr)",
    d: "m57.64 14.762.996-7.131"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ago4qnlhqct",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#68s8jbxarcs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ago4qnlhqct)",
    d: "m113.885 16.009.995-7.132"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jfnl8uunacv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g8cdrohgecu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#jfnl8uunacv)",
    d: "m69.977 50.788.996-7.132"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h7sqvv5hkcx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h61ewoyhzcw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#h7sqvv5hkcx)",
    d: "m88.35 20.87-7.071-1.508"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j6embe0jhcz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bw6kjwkbucy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#j6embe0jhcz)",
    d: "m59.618 32.59-7.097 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pb967wu7ucB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#67usej5pxcA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#pb967wu7ucB)",
    d: "m115.54 31.448-7.096 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a0fsutjelcD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0pq4br7dbcC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#a0fsutjelcD)",
    d: "m111.062 43.474-7.097 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fvv1zleafcF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bae8urgnecE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#fvv1zleafcF)",
    d: "m51.409 14.241-7.07-1.507"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mxovg2t8kcH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d9h8n62zocG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#mxovg2t8kcH)",
    d: "m107.654 15.488-7.071-1.508"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fxmae96sbcJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4npdfprocI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#fxmae96sbcJ)",
    d: "m78.503 35.918-7.096 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ws0jn7hsecL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1lurhjovcK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ws0jn7hsecL)",
    d: "m35.526 46.472-7.096 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ncb3mz885cN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vovfqq5uscM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ncb3mz885cN)",
    d: "m134.748 37.164-7.097 1.385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8c9fn65btcP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#645daa6pkcO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#8c9fn65btcP)",
    d: "m46.064 44.45 7.071 1.508"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "if8274ncccR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#05k4jev12cQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#if8274ncccR)",
    d: "m42.006 26.056-5.546 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ljai3070ccT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1qc0mjn70cS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ljai3070ccT)",
    d: "m98.251 27.302-5.547 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6ahvbo3w0cV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j9fr8nveacU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#6ahvbo3w0cV)",
    d: "m114.418 46.808-5.547 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lh8j6a9sfcX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8d2jlvxiocW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#lh8j6a9sfcX)",
    d: "m69.309 23.942-5.465-4.715"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ohmq3sns5cZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ibg7n2olbcY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ohmq3sns5cZ)",
    d: "M51.216 8.165 45.751 3.45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nm3md6gugdb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pm4072ydkda"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#nm3md6gugdb)",
    d: "m125.553 25.188-5.465-4.715"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m5fegafjhdd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4fnylk531dc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#m5fegafjhdd)",
    d: "m86.959 27.204-5.547 4.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bwys7sv8ydf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#59iuk9cm7de"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#bwys7sv8ydf)",
    d: "m52.916 24.207 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ozbv9r8y4dh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m2bfntwgpdg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#ozbv9r8y4dh)",
    d: "m109.161 25.453 4.735-5.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.615 73.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1jbww00c5dj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ptpjaxeqldi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D9D9C",
    strokeWidth: 0.948,
    mask: "url(#1jbww00c5dj)",
    d: "m79.768 13.088 4.735-5.442"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m244.527 68.544.333-22.56-11.919-2.735.241 23.772c-7.83 12.44-18.641 35.992-19.084 36.75-.824 1.41-4.644 1.535-5.908 2.152a.603.603 0 0 0-.295.785c.791 1.728 3.774-.302 4.402 2.482.606 2.686-3.857 5.525-1.303 6.982.39.147 3.98.53 5.283-2.07 1.532-3.058.502-6.644.953-7.569.572-1.17 25.25-32.647 25.25-32.647a8.326 8.326 0 0 0 2.047-5.342",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.407 77.65-.046-.001c-.36-.025-5.843-.383-3.227-1.085.35-.094 3.876-36.965-3.426-44.403-1.206-1.228-2.528-1.707-4.069-1.708-12.709-.01-18.615 44.968-18.615 44.968-.359.047-3.126.378-3.485.315a.658.658 0 0 1-.532-.763c.328-1.841 8.192-45.097 22.566-45.834 1.898-.1 3.608.61 5.07 2.1 8.785 8.943 6.519 44.297 6.418 45.798a.658.658 0 0 1-.654.613",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.776 163.555c-.29 5.839-17.355 9.734-38.116 8.7-20.762-1.035-37.357-6.607-37.067-12.446.29-5.838 17.354-9.732 38.116-8.697 20.762 1.034 37.357 6.605 37.067 12.443",
    fill: "#E10A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.253 126.921s-6.207-1.163-9.172 4.387c-2.967 5.55-5.55 4.948-5.303 6.95.246 2 1.644 2.494.81 3.819-.835 1.325 1.347 3.82 4.37 4.086 3.022.267 4.475-.315 8.025.94 3.549 1.254 5.724.577 6.878-.774 2.49-2.918 3.46-3.12 4.955-3.046 3.221.16 4.255-3.231 2.382-4.64-3.481-2.62-2.234-10.734-12.945-11.722",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.469 133.121s-5.791 10.974 5.463 11.88c10.392.838 8.38-9.689 5.607-11.906l-11.07.026z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86 216.34s39.1-16.641 44.816-10.276c5.716 6.366-27.797 29.746-27.797 29.746s1.525-11.955-9.581-9.603c0 0 3.27-10.158-7.439-9.868",
    fill: "#F3F2A7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.627 204.613)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pbwosqdoddl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kcq3haztwdk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.427 15.704S7.167-4.74.85 1.024C-5.47 6.79 25.564 33.388 25.564 33.388s-.334-12.047 10.485-8.603c0 0-2.248-10.433 8.378-9.08",
    fill: "#F3F2A7",
    mask: "url(#pbwosqdoddl)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.704 166.573s-.737 14.864 6.25 38.72c0 0-.535 2.722 1.363 3.379 1.802.621 2.078-.311 2.638-1.01.276-.346.424-.775.438-1.218l1.94-37.439-12.63-2.432z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.814 206.613c.344-4.958 1.66-28.97.638-38.857l-12.603 3.882 7.7 36.297c.103.55.444 1.03.94 1.284.576.293.607.53 1.851.278 1.582-.322 1.474-2.884 1.474-2.884",
    fill: "#BA7A45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m172.514 136.974 1.647-.495m-12.041-.072-1.594-.673",
    stroke: "#FEFEFE",
    strokeWidth: 1.476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DFE15C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.195 135.783s.053-1.505 2.429-1.262c2.486.255 2.932 1.406 2.893 2.17-.039.74-.994 1.897-3.306 1.787-2.313-.109-2.107-2.285-2.016-2.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.242 137.876c-.532-.025-.904-.18-1.14-.47-.397-.489-.339-1.266-.288-1.5 0 0 .03-.923 1.523-.8.073.005.148.008.226.015 1.542.14 2.365.687 2.321 1.539-.024.468-.718 1.307-2.642 1.216M172.912 136.337s.103-1.502-2.287-1.484c-2.5.018-3.064 1.122-3.104 1.885-.038.74.791 1.981 3.104 2.091 2.312.11 2.334-2.075 2.287-2.492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.656 138.227c.532.025.919-.093 1.184-.36.446-.45.469-1.228.442-1.465 0 0 .067-.921-1.432-.94-.073-.002-.148-.006-.226-.006-1.549-.006-2.425.46-2.47 1.312-.025.468.578 1.368 2.502 1.46z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 1.476,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m166.724 136.94 1.24.067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.146 132.957s2.239.88 6.51.917c4.27.037 6.505-.795 6.505-.795l-2.227-4.162-8.661.075-2.127 3.965z",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA7A45",
    d: "m171.948 149.99-9.563-.466.355-6.972 9.562.465z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176.56 123.828-.653 13.089a5.639 5.639 0 0 1-5.914 5.349l-2.428-.12",
    stroke: "#007371",
    strokeWidth: 2.214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.23 187.224c-31.189.032-42.063-11.396-42.758-18.449-.198-6.735 4.676-11.787 10.8-9.767 0 0 14.547 4.103 32.642 4.637 27.951.826 37.526-5.799 42.381 3.633.907 1.763.898 1.858.792 3.987l-.737 1.202c-.282 5.677-8.13 14.721-43.12 14.757",
    fill: "#E10A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.312 116.835c-7.377 25.306-21.031 35.926-32.139 38.962l-.562 8.379s-6.147 1.004-15.944.188c-5.18-.257-12.7-1.296-12.7-1.296l.288-8.707c-10.912-1.641-26.711 4.84-25.676 9.326.359 1.558 2.841 6.337 1.452 7.056-1.389.719-2.47-3.388-3.051-2.74-.452.5 1.747 4.027 2.574 5.532.827 1.506-.936 2.769-3.57-.81-3.096-4.203-1.314-9.796-1.314-9.796 6.191-20.194 37.855-16.944 37.855-16.944l3.92.195 1.48.074 11.53.572s21.167-2.153 32.15-31.436l2.14-.787 1.567 2.232z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.444 160.67s27.043 7.418 51.837 1.826",
    stroke: "#E10A0A",
    strokeWidth: 0.911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.058 145.962s.091 6.088 6.44 5.952c6.35-.135 6.607-5.304 6.607-5.304l4.35.216s-1.372 8.437 3.718 8.971l-.562 8.379s-10.88.59-16.473.162c-5.594-.428-12.171-1.27-12.171-1.27l.287-8.707s3.693-2.838 3.47-8.568l4.334.169z",
    fill: "#AAE2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.605 115.39c-.074-1.6-2.008-7.322-.514-7.782 1.495-.459 1.95 2.332 2.639 1.799.535-.414-.775-2.257-1.318-3.887s1.417-2.558 3.366 1.436c2.29 4.693-.466 9.879-.466 9.879",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.723 168.994 32.87 142.569a2.378 2.378 0 0 1 .52-2.59c1.67-1.666 5.448-4.381 12.317-4.34a2.398 2.398 0 0 1 2.18 1.422l15.206 34.404-19.371-2.471z",
    fill: "#9C3A83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.48 166.75 15.543-23.97a2.384 2.384 0 0 1 2.427-1.052c2.323.42 6.709 1.974 10.591 7.636.533.777.564 1.796.072 2.6l-19.622 32.095-9.011-17.308z",
    fill: "#9C3A83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.217 160.568s-3.283 1.584-16.331-3.785c-20.194-8.31-31.012 5.49-31.012 5.49l15.01 9.556 29.783-2.438 2.55-8.823z",
    fill: "#9C3A83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.581 207.63h-59.72a.789.789 0 0 1-.788-.789l.8-44.569 60.498.602v43.967a.79.79 0 0 1-.79.79",
    fill: "#F3F2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.353 162.998c0-6.865 5.572-12.43 12.443-12.43 6.872 0 12.442 5.565 12.442 12.43",
    stroke: "#F3F2A7",
    strokeWidth: 3.188
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationFamily);
export default __webpack_public_path__ + "static/media/illustration-family.903d3bf8326ae5dc689be5890505a082.svg";
export { ForwardRef as ReactComponent };